export const AlunoJson = {
    "cpf": "111.111.111-01",
    "inep": null,
    "completeName": " ",
    "birthDate": null,
    "filiation": {
        "haveFiliation": 0,
        "responsible1": null,
        "responsible2": null
    },
    "sex": 0,
    "colorRace": 0,
    "nationality": 0,
    "nationalityCountry": 0,
    "cityBorn": null,
    "existsDeficiencyDisorder": 0,
    "deficiencyDisorder": {
        "blindness": 0,
        "lowVision": 0,
        "monocularVision": 0,
        "deafness": 0,
        "hearingDeficiency": 0,
        "deafBlindness": 0,
        "physicalDisability": 0,
        "intellectualDisability": 0,
        "multipleDisability": 0,
        "autisticSpectrumDisorder": 0,
        "highSkills": 0
    },
    "countryResidence": 76,
    "cep": null,
    "cityResidence": null,
    "areaResidence": 0,
    "differentiatedLocation": 7,
    "idIEscolar": null,
    "wasChanged": false,
    "uf": null,
    "codeRegistration": null,
    "birthCertificateRegistration": null,
    "receiveEducationElsewhere": 0,
    "resourceEvaluationInep": {
        "readingAid": 0,
        "transcriptionAssistance": 0,
        "interpreterGuide": 0,
        "translatorInterpreterLibras": 0,
        "lipReading": 0,
        "extendedProof": 0,
        "overenlargedProof": 0,
        "cdVisuallyImpaired": 0,
        "secondLanguageDeafHearing": 0,
        "videoTestLibras": 0,
        "teachingMaterialBraille": 0,
        "brailleTest": 0, //new
        "additionalTime": 0, //new
        "none": 0
    },
    "specializedEducationTypes": {
        "developmentCognitiveFunctions": 0,
        "autonomousLifeDevelopment": 0,
        "curriculumEnrichment": 0,
        "affordableComputerEducation": 0,
        "teachingLibras": 0,
        "teachingPortugueseSecondLanguage": 0,
        "teachingCalculusTechniquesSoroban": 0,
        "teachingBrailleSystem": 0,
        "teachingUseOpticalNonOpticalResources": 0,
        "teachingTechniquesOrientationMobility": 0,
        "teachingCAA": 0
    },
    "schoolTransports": {
        "usesTransportPublic": 0,
        "responsiblePublicAuthority": 0,
        "vehicleTypes": {
            "roadBicycle": 0,
            "roadMinibus": 0,
            "roadBus": 0,
            "roadAnimalTraction": 0,
            "roadVanKombis": null,
            "roadOther": null,
            "waterways5": null,
            "waterways15": null,
            "waterways35": null,
            "waterwaysMore35": null
        }
    },
    "aclass": {
        "code": '',
        "codeInep": 0,
        "name": " ",
        "typeMediation": 0,
        "daysWeek": {
            "sunday": 0,
            "monday": 0,
            "tuesday": 0,
            "wednesday": 0,
            "thursday": 0,
            "friday": 0,
            "saturday": 0
        },
        "workingPlace": 0,
        "vocationalCourse": 0,
        "stage": 0,
        "typeServices": null,
        "multi": 0,
        "complementaryActivity": null,
        "startTime": null,
        "finishTime": null,
        "curricularStructures": {
            "basicGeneralTraining": 0,
            "formativeItinerary": 0,
            "noApplicable": 0
        },
        "formsOrganization": {
            "seriesYear": 0,
            "semesterPeriods": 0,
            "cycles": 0,
            "noSerialGroup": 0,
            "modules": 0,
            "regularAlternationPeriods": 0
        },
        "curricularUnit": {
            "electives": 0,
            "librasCU": 0,
            "indigenousLanguageCU": 0,
            "spanishLanguageCU": 0,
            "franchLanguageCU": 0,
            "otherLanguage": 0,
            "lifeProjectCU": 0,
            "learningTrails": 0,
            "othersUnitCurricular": 0
        },
        "curricularComponents": {
            "chemical": 0,
            "physical": 0,
            "mathematics": 0,
            "biology": 0,
            "sciences": 0,
            "portugueseLanguage": 0,
            "englishLanguage": 0,
            "spanishLanguageCC": 0,
            "anotherForeignLanguage": 0,
            "art": 0,
            "physicalEducation": 0,
            "history": 0,
            "geography": 0,
            "philosophy": 0,
            "informaticsComputing": 0,
            "customKnowledgeAreas": 0,
            "librasCC": 0,
            "areasPedagogicalKnowledge": 0,
            "religiousEducation": 0,
            "indigenousLanguageCC": 0,
            "socialStudies": 0,
            "sociology": 0,
            "frenchLanguageCC": 0,
            "portugueseSecondLanguage": 0,
            "supervisedInternship": 0,
            "lifeProjectCC": 0,
            "otherAreasKnowledge": 0
        },
        "haveLibrasFirstLanguagePortugueseSecond": 0,
        "wasChanged": false
    },
    "indigenousPeople": 0,
    "existsImpactfulLearningDisorder": 0,
    "impactfulLearningDisorder": {
        "dyscalculia": 0,
        "dysgraphia": 0,
        "dyslalia": 0,
        "dyslexia": 0,
        "TDAH": 0,
        "TPAC": 0
    }
}


export const profissionalJson = {
    "codePersonSystem": "IE2023VS02",
    "cpf": null,
    "inep": null,
    "completeName": null,
    "birthDate": null,
    "filiation": {
        "haveFiliation": 0,
        "responsible1": null,
        "responsible2": null
    },
    "sex": 0,
    "colorRace": 0,
    "nationality": 0,
    "nationalityCountry": 0,
    "cityBorn": null,
    "existsDeficiencyDisorder": 0,
    "deficiencyDisorder": {
        "blindness": 0,
        "lowVision": 0,
        "monocularVision": 0,
        "deafness": 0,
        "hearingDeficiency": 0,
        "deafBlindness": 0,
        "physicalDisability": 0,
        "intellectualDisability": 0,
        "multipleDisability": 0,
        "autisticSpectrumDisorder": 0,
        "highSkills": 0
    },
    "countryResidence": 76,
    "cep": null,
    "cityResidence": null,
    "areaResidence": 0,
    "differentiatedLocation": 7,
    "idIEscolar": null,
    "wasChanged": false,
    "uf": null,
    "inepRelation": null,
    "educationLevel": 0,
    "typeHighSchool": 0,
    "hiringRegime": 0,
    "pedagogicalComplementations": {
        "component1": 0,
        "component2": 0,
        "component3": 0
    },
    "especificFormations": {
        "nursery": 0,
        "preSchool": 0,
        "elementaryEarlyYears": 0,
        "finalYearsElementary": 0,
        "highSchool": 0,
        "eja": 0,
        "specialEducation": 0,
        "indigenousEducation": 0,
        "fieldEducation": 0,
        "environmentalEducation": 0,
        "humanRightsEducation": 0,
        "bilingualEducationDeaf": 0,
        "educationTIC": 0,
        "genderSexualDiversity": 0,
        "rightsChildrenAdolescents": 0,
        "ethnicCulturalEducation": 0,
        "schoolManagement": 0,
        "others": 0,
        "none": 0
    },
    "noHavePostGraduation": 1,
    "courses": [
        {
            "id": 0,
            "code": null,
            "conclusionYear": null,
            "institutionName": null,
            "courseName": null,
            "higherEducationInstitution": null,
            "deleted": false
        },
        {
            "id": 2,
            "code": null,
            "conclusionYear": null,
            "institutionName": null,
            "courseName": null,
            "higherEducationInstitution": null,
            "deleted": false
        }
    ],
    "postGraduations": [
        {
            "code": 0,
            "type": 0,
            "area": 0,
            "areaName": null,
            "conclusionYear": 2023
        },
        {
            "code": 2,
            "type": 0,
            "area": 0,
            "areaName": null,
            "conclusionYear": 2023
        }
    ],
    "function": null,
    "knowledgeAreas": null,
    "areaItineraryFormative": {
        "languagesTechnologies": 0,
        "mathematicsTechnologies": 0,
        "scienceTechnologies": 0,
        "humanScience": 0,
        "IFTP": 0,
    },
    "impactfulLearningDisorder": {  //new
        "dyscalculia": 0,
        "dysgraphia": 0,
        "dyslalia": 0,
        "dyslexia": 0,
        "TDAH": 0,
        "TPAC": 0

    }
}

export const gestorJson = {
    "codePersonSystem": "IE2023VS03",
    "cpf": null,
    "inep": null,
    "completeName": null,
    "birthDate": null,
    "filiation": {
        "haveFiliation": 0,
        "responsible1": null,
        "responsible2": null
    },
    "sex": 0,
    "colorRace": 0,
    "nationality": 0,
    "nationalityCountry": 0,
    "cityBorn": null,
    "existsDeficiencyDisorder": 0,
    "deficiencyDisorder": {
        "blindness": 0,
        "lowVision": 0,
        "monocularVision": 0,
        "deafness": 0,
        "hearingDeficiency": 0,
        "deafBlindness": 0,
        "physicalDisability": 0,
        "intellectualDisability": 0,
        "multipleDisability": 0,
        "autisticSpectrumDisorder": 0,
        "highSkills": 0
    },
    "cep": null,
    "cityResidence": null,
    "areaResidence": 0,
    "differentiatedLocation": 7,
    "idIEscolar": null,
    "wasChanged": false,
    "uf": null,
    "inepRelation": null,
    "educationLevel": 0,
    "typeHighSchool": 0,
    "hiringRegime": 0,
    "pedagogicalComplementations": {
        "component1": 0,
        "component2": 0,
        "component3": 0
    },
    "especificFormations": {
        "nursery": 0,
        "preSchool": 0,
        "elementaryEarlyYears": 0,
        "finalYearsElementary": 0,
        "highSchool": 0,
        "eja": 0,
        "specialEducation": 0,
        "indigenousEducation": 0,
        "fieldEducation": 0,
        "environmentalEducation": 0,
        "humanRightsEducation": 0,
        "bilingualEducationDeaf": 0,
        "educationTIC": 0,
        "genderSexualDiversity": 0,
        "rightsChildrenAdolescents": 0,
        "ethnicCulturalEducation": 0,
        "schoolManagement": 0,
        "others": 0,
        "none": 0
    },
    "noNoHavePostGraduation": 1,
    "courses": [
        {
            "id": 3,
            "code": null,
            "conclusionYear": null,
            "institutionName": null,
            "courseName": null,
            "higherEducationInstitution": null,
            "deleted": false
        },
        {
            "id": 4,
            "code": null,
            "conclusionYear": null,
            "institutionName": null,
            "courseName": null,
            "higherEducationInstitution": null,
            "deleted": false
        },
        {
            "id": 5,
            "code": null,
            "conclusionYear": null,
            "institutionName": null,
            "courseName": null,
            "higherEducationInstitution": null,
            "deleted": false
        }
    ],
    "postGraduations": [
        {
            "code": 3,
            "type": 0,
            "area": 0,
            "areaName": null,
            "conclusionYear": 2023
        },
        {
            "code": 4,
            "type": 0,
            "area": 0,
            "areaName": null,
            "conclusionYear": 2023
        },
        {
            "code": 5,
            "type": 0,
            "area": 0,
            "areaName": null,
            "conclusionYear": 2023
        }
    ],
    "email": null,
    "office": null,
    "accessCriteria": null
};
export const escolaJson = {
    "codeInep": 10000000,
    "email": null,
    "workingSituation": 0,
    "startDate": null,
    "finishDate": null,
    "name": null,
    "telephone": {
        "ddd": 0,
        "mainPhone": "",
        "secondaryPhone": ""
    },
    "codeTeachingBody": null,
    "schoolZone": 0,
    "localizationSchool": 0,
    "administrativeDependency": 0,
    "linkedInstitutions": {
        "secretaryMinistryEducation": 0,
        "secretarySecurityArmedForce": 0,
        "secretaryMinistryHealth": 0,
        "otherPublicBody": 0
    },
    "privateSchoolMaintainers": {
        "companiesPhysicalPerson": 0,
        "unionsAssociations": 0,
        "ong": 0,
        "nonProfitInstitution": 0,
        "systemS": 0,
        "oscip": 0
    },
    "privateSchoolCategory": null,
    "partnerPublicPowers": {
        "stateSecretary": 0,
        "municipalSecretary": 0,
        "nonePPP": 0
    },
    "formContractingPartnershipStateDepartmentEducation": {
        "collaborationTermFCPSDE": 0,
        "promotionTermFCPSDE": 0,
        "cooperationAgreementFCPSDE": 0,
        "serviceContractFCPSDE": 0,
        "financialTechnicalCooperationTermFCPSDE": 0,
        "consortiumContractFCPSDE": 0
    },
    "formContractingPartnershipMunicipalDepartmentEducation": {
        "collaborationTermFCPMDE": 0,
        "promotionTermFCPMDE": 0,
        "cooperationAgreementFCPMDE": 0,
        "serviceContractFCPMDE": 0,
        "financialTechnicalCooperationTermFCPMDE": 0,
        "consortiumContractFCPMDE": 0
    },
    "cnpjMaintainer": null,
    "cnpj": null,
    "regulation": 0,
    "spheresRegulatoryInstitution": {
        "federal": 0,
        "state": 0,
        "municipal": 0
    },
    "bindingUnit": 0,
    "codeSchoolHeadquarters": null,
    "codeIES": null,
    "uf": null,
    "totalProfessionals": {
        "secretaryAssistant": 0,
        "generalServicesAssistant": 0,
        "librarian": 0,
        "firemanHealthAssistantNurse": 0,
        "classDisciplineCoordinator": 0,
        "speechTherapist": 0,
        "nutritionist": 0,
        "psychology": 0,
        "foodPreparationProfessionals": 0,
        "professionalPedagogicalSupport": 0,
        "schoolSecretary": 0,
        "securityMan": 0,
        "responsibleTechnology": 0,
        "viceDirector": 0,
        "advisor": 0,
        "librasTranslatorInterpreter": 0,
        "agronomists": 0,
        "brailleProofreader": 0,
        "noneTP": 0
    },
    "schoolFood": 0,
    "indigenousSchool": 0,
    "languageTeaching": {
        "indigenousLanguage": 0,
        "portugueseLanguage": 0
    },
    "indigenousLanguageCodes": {
        "code1": 0,
        "code2": 0,
        "code3": 0
    },
    "hasDevelopmentEnvironmentalEducation": 0,
    "formsEnvironmentalEducation": {
        "experienceFields": 0,
        "specialCurricularComponent": 0,
        "curriculumAxis": 0,
        "inEvents": 0,
        "interdisciplinaryProjectsFEE": 0,
        "noneFEE": 0
    },
    "haveSelectionExam": 0,
    "quotaSystemReservation": {
        "ppi": 0,
        "income": 0,
        "publicSchool": 0,
        "pcd": 0,
        "otherGroupsNoListed": 0,
        "noneBroadCompetition": 0
    },
    "haveSite": 0,
    "shareSpaceIntegrationCommunity": 0,
    "useSurroundingSpacesEquipment": 0,
    "collegiateBodies": {
        "parentsAssociation": 0,
        "parentsTeacherAssociation": 0,
        "schoolCouncil": 0,
        "studentCouncil": 0,
        "others": 0,
        "noneCB": 0
    },
    "pedagogicalProjectProposal": 0,
    "wasChanged": false,
    "isPrivate": false,
    "headQuarters": {
        "code": 0,
        "workingPlace": {
            "schoolBuilding": 0,
            "classOtherSchool": 0,
            "shed": 0,
            "socioEducationalUnit": 0,
            "prisonUnit": 0,
            "otherWP": 0
        },
        "formOccupation": 0,
        "sharedBuilding": 0,
        "sharedSchoolCode": null,
        "haveDrinkingWater": 0,
        "waterSupply": {
            "publicNetworkWP": 0,
            "artesianWell": 0,
            "waterhole": 0,
            "source": 0,
            "waterCar": 0,
            "noneWS": 0
        },
        "powerSupply": {
            "publicNetworkPS": 0,
            "generator": 0,
            "renewableSource": 0,
            "nonePS": 0
        },
        "sanitarySewage": {
            "publicNetworkSS": 0,
            "septicCesspool": 0,
            "commonCesspool": 0,
            "noneSS": 0
        },
        "garbageDisposal": {
            "collectionService": 0,
            "burn": 0,
            "bury": 0,
            "licensedPublicPower": 0,
            "discardOtherArea": 0
        },
        "wasteTreatment": {
            "wasteSeparation": 0,
            "reuse": 0,
            "recycling": 0,
            "noneWT": 0
        },
        "existingPhysicalDependencies": {
            "warehouse": 0,
            "greenArea": 0,
            "auditorium": 0,
            "bathroom": 0,
            "accessibleBathroom": 0,
            "childEducationBathroom": 0,
            "exclusiveBathroomEmployees": 0,
            "bathroomShower": 0,
            "library": 0,
            "kitchen": 0,
            "pantry": 0,
            "studentDormitory": 0,
            "teacherDormitory": 0,
            "scienceLab": 0,
            "computerLab": 0,
            "professionalEducationLab": 0,
            "playground": 0,
            "coveredPatio": 0,
            "uncoveredPatio": 0,
            "pool": 0,
            "indoorSportsCourt": 0,
            "outdoorSportsCourt": 0,
            "refectory": 0,
            "studentRestRoom": 0,
            "artRoom": 0,
            "musicRoom": 0,
            "danceRoom": 0,
            "multipurposeRoom": 0,
            "bigLand": 0,
            "animalNursery": 0,
            "directorOffice": 0,
            "readingRoom": 0,
            "teachersRoom": 0,
            "secretaryRoom": 0,
            "professionalEducationRoom": 0,
            "recordingEditingStudio": 0,
            "agriculturalProduction": 0,
            "nonePD": 0,
            "aeeroom": 0
        },
        "accessibilityFeatures": {
            "handrailGuardrail": 0,
            "elevator": 0,
            "tactileFloors": 0,
            "freeDoors80cm": 0,
            "ramps": 0,
            "soundSignaling": 0,
            "tactileSignaling": 0,
            "visualSignage": 0,
            "lightAlarm": 0,
            "noneAF": 0
        },
        "numberIndoorRooms": 0,
        "numberRoomsOutside": 0,
        "numberAirconditionedRooms": 0,
        "numberAccessibleRooms": 0,
        "numberChildEducationRooms": 0,
    },
    "equipmentResource": {
        "id": 0,
        "administrativeTechnicians": {
            "antenna": 0,
            "computer": 0,
            "copyMachine": 0,
            "printer": 0,
            "multifunction": 0,
            "scanner": 0,
            "noneAT": 0
        },
        "teachingLearning": {
            "dvdPlayer": 0,
            "stereo": 0,
            "tv": 0,
            "digitalBlackboard": 0,
            "dataShow": 0
        },
        "pcStudents": {
            "desktopComputer": 0,
            "portableComputer": 0,
            "tablet": 0
        },
        "accessInternet": {
            "administrativeUse": 0,
            "teachingLearning": 0,
            "studentUse": 0,
            "communityUse": 0,
            "noAccessInternet": 0
        },
        "equipmentUsedAccessInternet": {
            "computerTablet": 0,
            "personalDevice": 0
        },
        "broadbandInternet": 0,
        "localComputerNetwork": {
            "cable": 0,
            "wireless": 0,
            "noneLCP": 0
        },
        "learningInstrumentsMaterial": {
            "multimediaCollection": 0,
            "childrenEducationToys": 0,
            "scientificSet": 0,
            "soundAmplificationBroadcastingEquipment": 0,
            "instrumentsBandsMusicClass": 0,
            "educationalGames": 0,
            "artisticCulturalActivities": 0,
            "professionalEducation": 0,
            "sportRecreation": 0,
            "pedagogicalMaterialsBilingualDeaf": 0,
            "indigenousSchoolEducation": 0,
            "racialEthnicRelations": 0,
            "fieldEducation": 0,
            "agricultureEquipment": 0,
            "quilombolaEducation": 0,
            "specialEducation": 0,
            "noneLIM": 0
        }
    },
    "address": {
        "id": 0,
        "cep": "",
        "city": null,
        "district": null,
        "publicPlace": null,
        "number": null,
        "complement": null,
        "neighborhood": null
    }
};